<template>
  <AppEditBookingsBaseDialog>

    <template slot="CaseAndAmount" slot-scope="props">
      <v-flex xs12 align-center justify-space-between>
        <v-select
          :items="props.casesList"
          v-model="props.selectedCase.id"
          label="Select case"
        ></v-select>
      </v-flex>

<!--       <v-flex xs12 align-center justify-space-between>
        <v-text-field
          v-model="props.amount.number"
          type="number"
          label="Amount"
        ></v-text-field>
      </v-flex> -->
    </template>

<!--     <template slot="ItemsSelection" slot-scope="props">
      <v-flex xs6 align-center justify-space-between>
        <v-btn-toggle mandatory v-model="props.selectedItemType.id">
          <v-btn flat :value="inventoryTypeID">Inventory</v-btn>
          <v-btn flat :value="serviceTypeID">Service</v-btn>
          <v-btn flat :value="caseManagerTypeID">Case Manager</v-btn>
        </v-btn-toggle>
      </v-flex>
    </template> -->

  </AppEditBookingsBaseDialog>
</template>

<script>
  import AppEditBookingsBaseDialog from '@/components/AppEditBookingsBaseDialog'
  import itemTypesMixins from '@/mixins/ItemTypes'

  export default {
    components: { AppEditBookingsBaseDialog },
    mixins: [ itemTypesMixins ]
  }
</script>



// WEBPACK FOOTER //
// AppEditBookingsDialog.vue?49c85466